import { render, staticRenderFns } from "./IncrementoSalarial.vue?vue&type=template&id=31abd760&scoped=true"
import script from "./IncrementoSalarial.vue?vue&type=script&lang=js"
export * from "./IncrementoSalarial.vue?vue&type=script&lang=js"
import style0 from "./IncrementoSalarial.vue?vue&type=style&index=0&id=31abd760&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31abd760",
  null
  
)

export default component.exports